module.exports = __webpack_public_path__ + "calculator/cummins-generator-calculator/calculator/cummins-generator-calculator/static/media/stars-white.92407627.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stars-white.svg
// module id = 813
// module chunks = 0